import React from 'react'
import { ContentBody, ContentHeader, RowSection, SectionContent } from '../layout'
import DataRow from './DataRow'
import { emptyValue, formatDateTime } from './helpers'
import { IOtaReservation } from 'static/interfaces'

interface IProps {
  otaReservation: IOtaReservation
}

const SalesChannelSectionContent = ({ otaReservation }: IProps) => {
  const channelManagerBookingId = otaReservation.channel_manager_booking_id

  return (
    <SectionContent>
      <ContentHeader>チャネル・販売情報</ContentHeader>
      <ContentBody className="single-column">
        <RowSection>
          <DataRow label="販売チャネル" content={emptyValue(otaReservation.seller)} />
          <DataRow label="販売者予約ID" content={emptyValue(otaReservation.seller_booking_id)} />
          <DataRow
            label="販売者予約日時"
            content={formatDateTime(otaReservation.seller_booking_created_at)}
          />
          <DataRow label="在庫管理" content={emptyValue(otaReservation.channel_manager)} />
          <DataRow
            label="在庫管理 予約ID"
            content={
              otaReservation.channel_manager === 'bokun' && channelManagerBookingId ? (
                <a
                  href={`https://japanwondertravel.bokun.io/sales/${channelManagerBookingId}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {channelManagerBookingId}
                </a>
              ) : (
                emptyValue(channelManagerBookingId)
              )
            }
          />
          <DataRow
            label="在庫管理 確認コード"
            content={emptyValue(otaReservation.channel_manager_confirmation_code)}
          />
          <DataRow
            label="商品確認コード"
            content={emptyValue(otaReservation.channel_manager_product_confirmation_code_list)}
          />
        </RowSection>
      </ContentBody>
    </SectionContent>
  )
}

export default SalesChannelSectionContent
